import axios from "axios";
import { getApiBaseUrl } from "../../config/api";
import {
    getRequest,
    getPageSuccess,
    getPublicListSuccess,
    stuffDone,
    getFailed,
    getError,
} from "./schoolPageSlice";

export const fetchSchoolPage = (schoolId) => async (dispatch) => {
    dispatch(getRequest());

    try {
        const result = await axios.get(`${getApiBaseUrl()}/SchoolPage/${schoolId}`);
        if (result.data.message && !result.data.schoolName) {
            dispatch(getFailed(result.data.message));
        } else {
            dispatch(getPageSuccess(result.data));
        }
    } catch (error) {
        dispatch(getError(error));
    }
};

export const saveSchoolPage = (schoolId, data) => async (dispatch) => {
    dispatch(getRequest());

    try {
        const result = await axios.put(`${getApiBaseUrl()}/SchoolPage/${schoolId}`, data, {
            headers: { "Content-Type": "application/json" },
        });
        if (result.data.message && !result.data.schoolId) {
            dispatch(getFailed(result.data.message));
        } else {
            dispatch(stuffDone());
        }
    } catch (error) {
        const msg =
            error.response?.data?.message ||
            error.response?.data?.hint ||
            error.message ||
            "Could not save school page";
        dispatch(getError(msg));
    }
};

export const publishPage = (schoolId, publicSlug) => async (dispatch) => {
    dispatch(getRequest());

    try {
        const body = publicSlug ? { publicSlug } : {};
        const result = await axios.put(
            `${getApiBaseUrl()}/SchoolPage/${schoolId}/publish`,
            body,
            { headers: { "Content-Type": "application/json" } },
        );
        if (typeof result.data.isPublished === "boolean") {
            dispatch(stuffDone());
        } else if (result.data.message) {
            dispatch(getFailed(result.data.message));
        } else {
            dispatch(stuffDone());
        }
    } catch (error) {
        const msg =
            error.response?.data?.message ||
            error.message ||
            "Could not publish school page";
        dispatch(getError(msg));
    }
};

export const unpublishPage = (schoolId) => async (dispatch) => {
    dispatch(getRequest());

    try {
        const result = await axios.put(`${getApiBaseUrl()}/SchoolPage/${schoolId}/unpublish`);
        if (result.data.isPublished === false) {
            dispatch(stuffDone());
        } else if (result.data.message) {
            dispatch(getFailed(result.data.message));
        } else {
            dispatch(stuffDone());
        }
    } catch (error) {
        dispatch(getError(error));
    }
};

export const fetchPublicSchools = () => async (dispatch) => {
    dispatch(getRequest());

    try {
        const result = await axios.get(`${getApiBaseUrl()}/PublicSchools`);
        if (result.data.message && !Array.isArray(result.data)) {
            dispatch(getFailed(result.data.message));
        } else {
            dispatch(getPublicListSuccess(result.data));
        }
    } catch (error) {
        dispatch(getError(error));
    }
};
